export default {
  title: "My Tickets",
  refresh: "Refresh",
  create: "Create",
  id: "Ticket ID",
  type: "Type",
  status: "Status",
  createdAt: "Created At",
  actions: "Actions",
  detailTitle: "Ticket Details",
  email: "Email",
  description: "Description",
  response: "Response",
  noResponse: "No response yet",
  statusPending: "Pending",
  statusResolved: "Resolved",
  statusClosed: "Closed",
};
